import { render } from "./SchemaModification.vue?vue&type=template&id=f7b4a1c2&scoped=true"
import script from "./SchemaModification.vue?vue&type=script&lang=js"
export * from "./SchemaModification.vue?vue&type=script&lang=js"

import "./SchemaModification.vue?vue&type=style&index=0&id=f7b4a1c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f7b4a1c2"

export default script